import React from 'react';

const Loader = ({ isFixed = true }) => {
    return (
        <div className={`main-loadder ${isFixed ? "" : "main-loader-relative"}`}>
            <div id="ftco-loader" className="show">
                <svg className="circular " width="48px" height="48px">
                    <circle
                        className="path-bg"
                        cx="24"
                        cy="24"
                        r="22"
                        fill="none"
                        strokeWidth="4"
                        stroke="#eeeeee"
                    />
                    <circle
                        className="path"
                        cx="24"
                        cy="24"
                        r="22"
                        fill="none"
                        strokeWidth="4"
                        strokeMiterlimit="10"
                        stroke="#52b347"
                    />
                </svg>
            </div>
            {/* <div className="loadder animation-group">
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 31.78 24.61"><g id="Group_40658"><path id="Path_48201" className="cls-3" d="m11,0h9.78c6.08,0,11,4.92,11,11v.11c0,6.08-4.92,11-11,11h-9.78C4.92,22.11,0,17.19,0,11.11v-.11C0,4.92,4.92,0,11,0Z" /><path id="Path_48200" className="cls-1" d="m9.67,5.53c3.05,0,5.53,2.47,5.53,5.53s-2.47,5.53-5.53,5.53-5.53-2.47-5.53-5.53c0-3.05,2.47-5.53,5.53-5.53h0Z" /><path id="Path_48199" className="cls-1" d="m22.11,5.53c3.05,0,5.53,2.47,5.53,5.53s-2.47,5.53-5.53,5.53-5.53-2.47-5.53-5.53c0-3.05,2.47-5.53,5.53-5.53h0Z" /><path id="Path_48003" className="cls-2" d="m24.6,11.03c.06,1.52-1.13,2.79-2.65,2.85-.06,0-.12,0-.18,0-.81.01-1.58-.31-2.15-.88l.52-.72c.42.42.99.67,1.59.69,1.02,0,1.85-.83,1.84-1.85,0-.03,0-.07,0-.1.05-.98-.7-1.82-1.68-1.88-.05,0-.1,0-.15,0-.55.02-1.08.22-1.49.58l-.48-.74c.55-.5,1.27-.77,2.02-.75,1.52-.04,2.77,1.17,2.81,2.68,0,.04,0,.08,0,.12Z" /><path id="Path_48004" className="cls-2" d="m7.19,11.03c-.06,1.52,1.13,2.79,2.65,2.85.06,0,.12,0,.18,0,.81.01,1.58-.31,2.15-.88l-.52-.72c-.42.42-.99.67-1.59.69-1.02,0-1.85-.83-1.84-1.85,0-.04,0-.07,0-.11-.05-.98.7-1.82,1.68-1.87.05,0,.1,0,.15,0,.55.02,1.08.22,1.49.58l.48-.74c-.55-.51-1.27-.77-2.02-.75-1.52-.04-2.77,1.17-2.81,2.68,0,.04,0,.08,0,.12Z" /><path id="Path_48203" className="cls-3" d="m20.41,22.11l-4,2.5v-5l4,2.5Z" /></g></svg>
                <img src={loaderImgShadow} alt="loaderImgShadow" />
            </div> */}

        </div>
    )
}

export default Loader;